/**
 * Extension point for custom units and lessons. Add a new `registerUnit` call
 * here (or in another module imported from `main.tsx`) to add your own content.
 *
 * Lesson factories return a config created by one of the templates in
 * `learn/engine/lessonsModel.ts`.
 */
import { IdeDemo, IdeLesson } from "../learn/engine/lessonsModel";
import {
  registerUnit,
  type LessonFactory,
} from "../learn/engine/lessonRegistry";

export function registerCustomLessons(): void {
  registerUnit("Custom", [customLesson1, customLesson2], {
    js: `function main() {
  move();
  pickBeeper();
}`,
    python: `def main():
    move()
    pick_beeper()`,
  });
}

const customLesson1: LessonFactory = () => IdeDemo("u13l1");

const customLesson2: LessonFactory = () => IdeLesson("u13l2");
